import router from "./router";
import store from './store';
import { ElMessage } from 'element-plus';
import { t } from '@/utils/i18nT';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { ensureFreshAccessToken, refreshStandaloneAuthority } from '@/utils/silentAuth';
import { getAuth, isStandaloneCustomer } from '@/utils/auth';
import { isBusinessRouteAllowed } from '@/utils/businessRouteAccess';

const WHITE_LIST = new Set(['/', '/404', '/401']);
/** 仅这些路由需要 DataV 组件，按需动态加载插件以减小首包 */
const DATAV_ROUTE_NAMES = new Set(['daping', 'displayLarge']);

NProgress.configure({
    showSpinner: true,
    easing: 'ease',
    speed: 400
});

let dataVInstallPromise = null;
function ensureDataV(app) {
    if (!dataVInstallPromise) {
        dataVInstallPromise = import('@jiaminghi/data-view').then(({ default: dataV }) => {
            app.use(dataV);
        });
    }
    return dataVInstallPromise;
}

function guardBusinessRoute(to, next) {
    const aliases = { '/jiqidetails': '/machine', '/machaisle': '/machine', '/hangar': '/goods', '/warehouse_reper': '/warehouse', '/role_editor': '/role', '/role_mage': '/role' };
    const path = aliases[to.path] || to.path;
    const permitted = !isStandaloneCustomer() || ['/home', '/index'].includes(path) || [4, 7].includes(Number(getAuth(path)));
    if (permitted && isBusinessRouteAllowed(to.path)) {
        return true;
    }
    ElMessage({
        type: 'error',
        message: t('no permission to access this page')
    });
    next('/401');
    return false;
}

function guardSuperAdminRoute(to, next) {
    if (!to.meta?.superAdminOnly || Number(store.getters.authid) === 8) {
        return true;
    }
    ElMessage({
        type: 'error',
        message: t('no permission to access this page')
    });
    next('/401');
    return false;
}

/**
 * Register before app.use(router) starts the initial deep-link navigation.
 * @param {import('vue').App} app
 */
export function setupPermissionGuards(app) {
    router.beforeEach(async (to, from, next) => {
        store.commit('UPDATE_ROUTER_LOADING', true);
        NProgress.start();
        try {
            if (DATAV_ROUTE_NAMES.has(to.name)) {
                await ensureDataV(app);
            }
            if (WHITE_LIST.has(to.path)) {
                next();
            } else {
                try {
                    await ensureFreshAccessToken();
                    await refreshStandaloneAuthority();
                } catch (error) {
                    ElMessage({
                        type: 'error',
                        message: t('loginSessionExpired')
                    });
                    next('/');
                    return;
                }
                if (!guardBusinessRoute(to, next)) return;
                if (!guardSuperAdminRoute(to, next)) return;
                next();
            }
        } catch (err) {
            console.error(err);
            next(false);
        }
    });

    router.afterEach(() => {
        store.commit('UPDATE_ROUTER_LOADING', false);
        NProgress.done();
    });

    router.onError(err => {
        console.error(err);
        store.commit('UPDATE_ROUTER_LOADING', false);
        NProgress.done();
    });
}
